import React, { useEffect } from "react";
import ProfileCard from "./ProfileCard";
import { Col, Row } from "antd";
import CustomTabs, { tabsProps } from "../../components/Tabs";
import About from "./Tabs/About";
import ProfileDeails from "./Tabs/Profile";
import Job from "./Tabs/Job";
import Doccuments from "./Tabs/Doccuments";
import Assets from "./Tabs/Assets";
import IDCard from "./Tabs/IDCard";
import ReportingCards from "../home/ReportingCards";
import { useSelector } from "react-redux";
import { constants } from "../../constants/common";
import { useNavigate } from "react-router-dom";
import Claims from "./Tabs/Claims/Claims";

const Profile = () => {
  const [activeTab, setActiveTab] = React.useState<string>('about');
  const { app: { user } } = useSelector((state: any) => ({
    app: state.app
  }));
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/profile/about')
  }, [])

  console.log("useruser", user)

  const tabs: tabsProps[] = [{
    key: 'about',
    label: 'About',
    content: <About />
  }, {
    key: 'profile-details',
    label: 'Profile',
    content: <ProfileDeails />
  },
  {
    key: 'job',
    label: 'Job',
    content: <Job />
  },
  {
    key: 'claims',
    label: 'Claims',
    content: <Claims />
  },
    // {
    //   key: 'doccuments',
    //   label: 'Doccuments',
    //   content: <Doccuments />
    // },
    // {
    //   key: 'assets',
    //   label: 'Assets',
    //   content: <Assets />
    // },
    // {
    //   key: 'id-card',
    //   label: 'ID Card',
    //   content: <IDCard />
    // }
  ]

  const onTabChange = (key: string) => {
    console.log(key);
    setActiveTab(key);
  }

  return (
    <Row gutter={[10, 10]}>
      <Col span={20}>
        <Row gutter={[10, 10]}>
          <Col span={24}>
            <ProfileCard
              name={`${user?.firstName} ${user?.lastName}`}
              jobTitle={user?.jobTitles?.name}
              location={user?.location?.name}
              email={user?.email}
              phone={user?.mobile}
              empId={user?.employeeId}
              businessUnit={user?.businessUnit?.name}
              reportingTo={user?.reportingManager ? constants.GET_FULL_NAME(user?.reportingManager) : ''}
              workMode={user?.workType?.name}
            />
          </Col>
          <Col span={24}>
            <CustomTabs
              tabs={tabs}
              defaultActiveKey={activeTab}
              onTabChange={onTabChange}
              routes={true}
            />
          </Col>
        </Row>
      </Col>
      <Col span={4}>
        <ReportingCards />
      </Col>
    </Row>
  )
}

export default Profile;